import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import NotificationCenterView from '../component/NotificationCenterView'
import NotificationCenterItem from '../blocks/NotificationCenterItem/container/NotificationCenterItem'
import { getUnreadConversations } from '../../../shared/chat'
import { NOTIFICATION_TYPES } from '../../../constants'
import { PATHS } from '../../../Config/Routing/paths'
import { updateTabName } from '../../../Config/Routing/Util'
import { history as historyConfig } from '../../../Config/history'

const NotificationCenter = withRouter(({ history, websockets }) => {
  const [notifications, setNotifications] = useState([])
  const [isActive, setIsActive] = useState(false)
  const toggleIsActive = () => setIsActive(!isActive)

  useEffect(() => {
    const chatNotifications = getChatNotificationsData()
    const notifications = chatNotifications.map((notificationData, index) => (
      <NotificationCenterItem
        key={`${notificationData.type}-${notificationData.id}`}
        type={notificationData.type}
        title={notificationData.title}
        description={notificationData.description}
        action={notificationData.action}
      />
    ))
    setNotifications(notifications)
    updateTabName(history.location.pathname, notifications.length)

    return () => {
      setNotifications([])
    }
  }, [websockets.messages, websockets.conversations])

  useEffect(() => {
    updateTabName(history.location.pathname, notifications.length)
    historyConfig.listen(({ pathname }) =>
      updateTabName(pathname, notifications.length),
    )
  }, [])

  const getChatNotificationsData = () => {
    const { messages, conversations } = websockets

    const unreadConversations = getUnreadConversations({
      conversations: Object.values(conversations),
      messages,
      isEndUser: false,
    })

    return unreadConversations.map(conversation => {
      const action = () => {
        history.push(`${PATHS.main.dashboard}${PATHS.dashboard.chat}`, {
          conversationId: conversation.id,
        })
        setIsActive(false)
      }
      return {
        id: conversation.id,
        type: NOTIFICATION_TYPES.CHAT,
        title: conversation.name,
        description: messages[conversation.orderedMessages[0]].payload.text,
        action,
      }
    })
  }

  return (
    <NotificationCenterView
      count={notifications.length}
      toggleView={toggleIsActive}
      isActive={isActive}
    >
      {notifications}
    </NotificationCenterView>
  )
})

const mapStateToProps = state => {
  return {
    websockets: state.websockets,
  }
}

export default connect(mapStateToProps)(NotificationCenter)



// WEBPACK FOOTER //
// ./src/Components/NotificationCenter/container/NotificationCenter.js